<template>
  <div class="container w1200">
    <!-- <a-row type="flex" class="a-row" justify="center">
      <a-col :span="16"> -->
    <div class="breadcrumb flex w1200">
      <span>当前位置：</span>
      <a-breadcrumb separator=">">
        <a-breadcrumb-item>
          <router-link :to="{ path: '/WebIndex/Home' }">
            首页
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <span>{{ routeData.name }}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <!-- 标签页 -->
    <a-tabs
      w1200
      v-if="NavigationStatus"
      :tab-position="tabPosition"
      v-model="activeKey"
      @change="callback"
    >
      <template v-for="(item, index) in tabsList">
        <a-tab-pane :tab="item.name" :key="index" v-if="item.id !== 40">
          <div class="tablist" v-if="tabsList.length !== 0">
            <div
              class="list flex"
              v-for="(item, index) in articleData.list"
              :key="index"
              @click="RowClick(item)"
            >
              <div class="a-img flex flexAi-c flexJc-c">
                <img class="image" :src="item.img" alt="" />
              </div>
              <div class="data-r">
                <div class="title Fs28 FontW6">{{ item.name }}</div>
                <div class="time">
                  {{ item.releaseTime | FilterDataTime }}
                </div>
                <div class="dtl">{{ item.text | getText }}</div>
              </div>
            </div>
            <div
              class="pagination flex flexAi-c flexJc-sb"
              v-if="articleData !== ''"
            >
              <a-pagination
                size="Default"
                :defaultPageSize="articleData.pageSize"
                @change="pagination"
                v-model="pages.pageNum"
                :total="articleData.total"
                :item-render="itemRender"
              />
              <div class="total">
                <span
                  >共 {{ articleData.total }} 条数据/{{
                    articleData.pages
                  }}页</span
                >
              </div>
              <!-- <div class="goto flex">
                      <a-input></a-input>
                      <a-button type="">跳转</a-button>
                    </div> -->
            </div>
          </div>
        </a-tab-pane>
      </template>
    </a-tabs>
    <div class="tablist" v-else>
      <div
        class="list flex flexAi-c"
        v-for="(item, index) in articleData.list"
        :key="index"
        @click="RowClick(item)"
      >
        <div class="a-img flex flexAi-c flexJc-c">
          <img class="image" :src="item.img" alt="" />
        </div>
        <div class="data-r">
          <div class="title Fs28 FontW6">{{ item.name }}</div>
          <div class="time">
            {{ item.releaseTime | FilterDataTime }}
          </div>
          <div class="dtl">{{ item.text | getText }}</div>
        </div>
      </div>
      <div class="pagination flex flexAi-c flexJc-sb" v-if="articleData !== ''">
        <a-pagination
          size="Default"
          :defaultPageSize="articleData.pageSize"
          @change="pagination"
          v-model="pages.pageNum"
          :total="articleData.total"
          :item-render="itemRender"
        />
        <div class="total">
          <span
            >共 {{ articleData.total }} 条数据/{{ articleData.pages }}页</span
          >
        </div>
        <!-- <div class="goto flex">
                      <a-input></a-input>
                      <a-button type="">跳转</a-button>
                    </div> -->
      </div>
    </div>
    <!-- </a-col>
    </a-row> -->
  </div>
</template>

<script>
let that
export default {
  name: '',
  props: [''],
  data() {
    return {
      tabPosition: 'left', // 标签显示方向
      screenWidth: '', // 屏幕宽
      routeData: '', // 传参数据
      activeKey: '',
      NavigationStatus: true, // 判断有无二级栏目 true有
      tabsList: [],
      articleData: '',
      dataList: [],
      pages: {
        pageNum: 1,
        pageSize: 6
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    that = this
    // 监听进度条滚动
    that.screenWidth = window.innerWidth
    if (that.screenWidth <= 1026) {
      that.tabPosition = 'top'
    } else {
      that.tabPosition = 'left'
    }
    this.onresize()
    if (this.$route.query.info !== undefined) {
      this.routeData = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.routeData)
      this.activeKey = this.routeData.index
      // if (this.routeData.list !== null) {
      this.NavigationBarfFindById()
      // } else {
      // this.FindByNavigationId()
      // }
    }
  },

  methods: {
    callback(e) {
      console.log(e)
      this.FindByNavigationId()
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a>上一页</a>
      } else if (type === 'next') {
        return <a>下一页</a>
      }
      return originalElement
    },
    // 分页
    pagination(e) {
      console.log(e)
      this.pages.pageNum = e
      document.body.scrollTop = document.documentElement.scrollTop = 180
      this.FindByNavigationId()
    },
    RowClick(item) {
      console.log(item)
      let name
      if (this.NavigationStatus) {
        name = this.tabsList[this.activeKey].name
      } else {
        name = '文章详情'
      }
      const data = {
        id: item.id,
        firstTitle: this.routeData.name,
        name: name
      }
      this.$router.push({
        path: '/WebIndex/DataDtl',
        query: {
          info: this.$Base64.encode(JSON.stringify(data))
        }
      })
    },
    // 自适应-监听
    // 监听窗口宽度
    onresize() {
      addEventListener('resize', () => {
        // that.screenWidth = document.body.clientWidth
        // @media是滚动条一起计算的。
        // js判断屏幕宽度并且配合@media时应使用window.innerWidth来获取宽度
        that.screenWidth = window.innerWidth
        if (that.screenWidth <= 1026) {
          that.tabPosition = 'top'
        } else {
          that.tabPosition = 'left'
        }
        // if (clientWidth < 768) {
        //   //当屏幕小于768时，设置Vuex里的数据为true
        //   this.$store.commit('SET_MOBLIE', true)
        // } else {
        //   //反之，设置Vuex里的数据为false
        //   this.$store.commit('SET_MOBLIE', false)
        // }
      })
    },
    // 接口
    // 根据id查询子导航
    NavigationBarfFindById() {
      this.isDataDetails = false
      this.$postAxios('/navigation/findLevelTwo', {
        parentId: this.routeData.id
      }).then(res => {
        // 用于判断有无二级栏目来展示列表样式
        if (res.status === '0') {
          this.NavigationStatus = true
          this.tabsList = res.data
          this.FindByNavigationId()
        } else if (res.status === '10003') {
          this.NavigationStatus = false
          // this.list = []
          // this.articleData = ''
          this.FindByNavigationId()
        }
      })
    },
    // 根据栏目id查询文章列表
    FindByNavigationId() {
      let typeId = ''
      if (this.NavigationStatus) {
        typeId = this.tabsList[this.activeKey].id
      } else {
        typeId = this.routeData.id
      }
      this.articleData = ''
      this.$postAxios('/article/findAll', {
        status: 1,
        type: typeId,
        page: this.pages.pageNum,
        size: this.pages.pageSize
        // parentType:
      }).then(res => {
        if (res.status === '0') {
          this.articleData = res.data
          console.log(this.articleData)
        }
      })
    }
  },

  watch: {
    $route(to, from) {
      // console.log(from)
      // console.log(to)

      if (
        to.path === '/WebIndex/DataList' &&
        to.query.info !== from.query.info
      ) {
        // this.Navdata = to.query
        this.routeData = JSON.parse(this.$Base64.decode(to.query.info))
        console.log(this.routeData)
        this.activeKey = this.routeData.index
        this.NavigationBarfFindById()
      }
      // // 判断是从文章详情页过来在加载一下文章，因为使用了keep-alive（组件缓存）所以需要重新触发
      // // 写这个原因是因为用户点击浏览器返回键，左侧栏不返回到原来的选中列表
      // if (
      //   from.path === '/DataDetails' &&
      //   this.$route.query.choose !== undefined &&
      //   to.path === '/DataLeft'
      // ) {
      //   console.log(1111)

      //   this.Navdata = this.$route.query
      //   this.NavigationBarfFindById()
      // }
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  .breadcrumb {
    padding: 30px 0;
  }
  .ant-tabs {
    padding-bottom: 30px;
    /deep/ .ant-tabs-bar {
      width: 200px;
      text-align: center;
      .ant-tabs-tab-prev {
        height: 40px;
      }
      .ant-tabs-tab {
        font-size: 18px !important;
        text-align: center;
      }
      .ant-tabs-tab-active {
        background: #2b9dcf;
        color: #fff;
      }
    }
    .tablist {
      .list {
        padding: 20px;
        .a-img {
          background: #fff;
          width: 250px;
          height: 180px;
        }
        .data-r {
          padding-left: 20px;
          width: 58%;
          .title {
            padding-bottom: 10px;
          }
          .time {
            padding: 10px 0;
          }
          .dtl {
            color: #8a8687;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
      }
      .list:hover {
        cursor: pointer;
        background: #f3f3f3;
      }
      .pagination {
        padding: 20px 0;
      }
    }
  }
  .tablist {
    .list {
      padding: 20px;
      .a-img {
        background: #fff;
        width: 250px;
        height: 180px;
      }
      .data-r {
        padding-left: 20px;
        width: 58%;
        .title {
          padding-bottom: 10px;
        }
        .time {
          padding: 10px 0;
        }
        .dtl {
          color: #8a8687;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
    .list:hover {
      cursor: pointer;
      background: #f3f3f3;
    }
    .pagination {
      padding: 20px 0;
    }
  }
}
@media (max-width: 1026px) {
  .container {
    .ant-tabs {
      padding-bottom: 30px;
      /deep/ .ant-tabs-bar {
        width: 100%;
      }
      .tablist {
        .list {
          flex-direction: column;
          .a-img {
            display: none !important;
          }
          .data-r {
            width: 100%;
            padding-left: 20px;
            .title {
              font-size: 18px;
              padding-bottom: 10px;
            }
            .time {
              padding: 10px 0;
            }
          }
        }

        .pagination {
          padding: 20px 0;
        }
      }
    }
    .tablist {
      flex-direction: column;
    }
  }
}
</style>
